// eslint-disable
const configApp = require('../../app.json');

// import websdk from '../sdks';
// @ts-ignore
import xmldom from 'xmldom';
// eslint-enable
import config from './webIMConfig';

import { WebIM as _webIM } from '../sdks/src/connection';

// init DOMParser / document for strophe and sdk
// window.WebIM.config.isDebug = true
// eslint-disable
// eslint-disable-next-line no-global-assign
console = console || {};
// eslint-enable
console.group = console.group || function () {};
console.groupEnd = console.groupEnd || function () {};

// eslint-disable-next-line no-multi-assign
// @ts-ignore
window.WebIM = _webIM;
// @ts-ignore
window.WebIM.config = config;
// @ts-ignore
const WebIM = window.WebIM;
window.DOMParser = xmldom.DOMParser;
let document = {};
if (configApp && !configApp.isWebApp) {
  // eslint-disable-next-line no-multi-assign
  document = window.document = new DOMParser().parseFromString("<?xml version='1.0'?>\n", 'text/xml');
}

function ts() {
  const d = new Date();
  const Hours = d.getHours(); // current hour (0-23)
  const Minutes = d.getMinutes(); // current min (0-59)
  const Seconds = d.getSeconds(); // current sec (0-59)
  return `${Hours < 10 ? `0${Hours}` : Hours}:${Minutes < 10 ? `0${Minutes}` : Minutes}:${Seconds < 10 ? `0${Seconds}` : Seconds} `;
}

if (WebIM.config.isDebug) {
  // @ts-ignore
  window.Strophe.log = function (level: any, msg: string) {
    try {
      // console.group('%crecv # ' + ts(), 'color: blue; font-size: large')
      // console.log('%c ' + ts() + ' recv: ' + msg, 'color: green');
      // console.groupEnd()
    } catch (e) {
      console.log('window.Strophe.log exception', e);
    }
  };

  window.Strophe.Connection.prototype.rawOutput = function (data: any) {
    try {
      // console.group('%csend # ' + ts(), 'color: blue; font-size: large')
      console.log(`%c ${ts()} send: ${data}`, 'color: blue');
      // console.groupEnd()
    } catch (e) {
      console.log(e);
    }
  };
}

// var stropheConn = new window.Strophe.Connection("ws://im-api.hyphenate.io/ws/", {
//                 inactivity: 30,
//                 maxRetries: 5,
//                 pollingTime: 4500
//             });
//
// stropheConn.connect(
//   'hyphenatedemo#chatdemoui_liuwz@hyphenate.io',
//   '$t$' + 'YWMtmbQEBKKIEeaGmMtXyg5n1wAAAVlkQvGO2WOJGlMCEJKM4VV9GCMnb_XLCXU',
//   function() {
//     console.log(arguments, 'ggogogo');
//   }, stropheConn.wait, stropheConn.hold);

WebIM.conn = new WebIM.connection({
  isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
  https: WebIM.config.https,
  url: WebIM.config.xmppURL,
  isAutoLogin: true,
  heartBeatWait: WebIM.config.heartBeatWait,
  pingTimeout: WebIM.config.pingTimeout,
  isHeartBeatEnable: WebIM.config.isHeartBeatEnable,
  autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
  autoReconnectInterval: WebIM.config.autoReconnectInterval,
  isHttpDNS: WebIM.config.isHttpDNS,
  apiUrl: WebIM.config.apiURL,
  isWindowSDK: WebIM.config.isWindowSDK,
  encrypt: WebIM.config.encrypt,
  delivery: WebIM.config.delivery,
  domain: WebIM.config.domain,
  numberOfUnackMsgToCheckForReceipt: WebIM.config.numberOfUnackMsgToCheckForReceipt,
  limitSecondTimeGetGroupChatMessage: WebIM.config.limitSecondTimeGetGroupChatMessage,
});

export default WebIM;
